/* 🤖 this file was generated by svg-to-ts */
export const iconXaut0: {
  name: 'xaut_0';
  data: string;
} = {
  name: 'xaut_0',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#xaut0__clip0_2972_16)"><path fill="#fff" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#C89A34" fill-rule="evenodd" d="M16 32c8.84 0 16-7.16 16-16S24.84 0 16 0 0 7.16 0 16s7.16 16 16 16M7.82 7.64h16.36v3.64h-6.36v3.64h-3.64v-3.64H7.82zm6.36 7.27v7.27h-3.64v-7.27zm3.64 0h3.64v7.27h-3.64v3.64h-3.64v-3.64h3.64z" clip-rule="evenodd"/></g><defs><clipPath id="xaut0__clip0_2972_16"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
